import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components";
import { logoIconDataUri } from "@src/assets/logo-icon-data-uri";

import LogoType from "@src/assets/svgs/logo-type.svg";

const LOGO_HEIGHT = 32;
const ICON_WIDTH = 33;
const TYPE_WIDTH = 91;

interface LogoProps {
  collapsed?: boolean;
}

export function Logo({ collapsed = false }: LogoProps) {
  const { theme } = useUnistyles();

  if (collapsed) {
    return (
      <View alignItems="center" justifyContent="center">
        <img src={logoIconDataUri} width={ICON_WIDTH} height={LOGO_HEIGHT} alt="" />
      </View>
    );
  }

  return (
    <View flexDirection="row" alignItems="center" gap="md">
      <img src={logoIconDataUri} width={ICON_WIDTH} height={LOGO_HEIGHT} alt="" />
      <LogoType width={TYPE_WIDTH} height={LOGO_HEIGHT} color={theme.colors.text} />
    </View>
  );
}
